import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'masthead-usage',
  templateUrl: './masthead-usage.component.html',
  styleUrls: ['./masthead-usage.component.sass']
})
export class MastheadUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
